export default {
  title: {
    regular: 'Modificatori standard per prodotti',
    meal: 'Crea il tuo articolo menu combinato',
    upsell: 'Crea il tuo gruppo di upsell',
  },
  description: {
    regular:
      'Seleziona i modificatori da includere nel nuovo gruppo, anche se già presenti in altri gruppi. Puoi anche creare il gruppo e aggiungere modificatori in seguito.',
    meal: 'Seleziona i prodotti da includere nel menu combinato. Se i prodotti non esistono ancora, creali nella pagina "Gestione menu". Assicurati di collegare l\'articolo menu combinato ai prodotti corretti nella sezione "Modificatori" del costruttore prodotti.',
    upsell:
      'Seleziona i prodotti da includere nel gruppo di upsell. Se i prodotti non esistono ancora, creali nella pagina "Gestione menu". Assicurati di collegare l\'articolo di upsell ai prodotti corretti nella sezione "Modificatori" del costruttore prodotti.',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Inserisci nome gruppo modificatori',
    },
    max_quantity: {
      label: 'Quantità massima',
      placeholder: 'Quantità massima modificatori',
    },
    is_required: {
      label: 'Obbligatorio',
    },
  },
  labels: {
    visible: 'Visibile',
    hidden: 'Nascosto',
    multiply: 'Moltiplicabile',
  },
  buttons: {
    save: 'Salva',
    close: 'Chiudi',
  },
  toasts: {
    modifier_group_got_created: 'Gruppo modificatori creato',
    modifier_group_got_updated: 'Gruppo modificatori aggiornato',
  },
};
